import {inlineError, streamify} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
class ContactModelSellerUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {HTTPSellerRepository} deps.hTTPSellerRepository
   * @param {contactModelSellerRequest} deps.contactModelSellerRequest
   */
  constructor({contactModelSellerRequest, hTTPSellerRepository, genericErrorFactory}) {
    super({
      hTTPSellerRepository,
      contactModelSellerRequest,
      genericErrorFactory
    })

    this._contactModelSellerRequestFactory = contactModelSellerRequest
    this._hTTPSellerRepository = hTTPSellerRepository
    this._genericSellerErrorFactory = genericErrorFactory
  }

  /**
   * @return {Array.<{error, response}>} returns the contact response status
   */
  @inlineError
  execute(params) {
    const contactModelSellerRequest = this._contactModelSellerRequestFactory(params)

    return this._hTTPSellerRepository
      .contactModelSeller(contactModelSellerRequest)
      .then(([contactError, contactResponse]) => {
        return contactError ? Promise.reject(this._genericSellerErrorFactory(contactError)) : contactResponse.toJSON()
      })
  }
}

export {ContactModelSellerUseCase}
